// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notifications {
  position: absolute;
  top: 53px;
  right: 0;
  width: 350px;
  background-color: #fff;
  border-radius: 5px;
  border: 1px solid rgba(204, 204, 204, 0.397);
  box-shadow: 0 0 5px 0px rgba(204, 204, 204, 0.589);
  transition: 300ms;
  padding: 5px 0;
  z-index: 22;
  max-height: 400px;
  overflow: auto;
}
.notifications .head {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  color: #5e5873;
  border-bottom: 1px solid rgba(204, 204, 204, 0.493);
}
.notifications .head p {
  font-size: 18px;
  margin: 0;
}
.notifications .head span {
  font-size: 13px;
  background-color: rgba(15, 127, 62, 0.1215686275);
  color: #0f7f3d;
  border-radius: 10px;
  padding: 0 10px;
  height: 22px;
}
.notifications .items {
  width: 100%;
  max-height: 300px;
}
.notifications .items div:last-child {
  border: none;
}
.notifications .readAll {
  padding: 15px;
  width: 100%;
  border-top: 1px solid rgba(204, 204, 204, 0.493);
}
.notifications .readAll button {
  width: 100%;
  border: none;
  background: var(--linkActive);
  color: #fff;
  border-radius: 5px;
  padding: 6px;
  transition: 200ms;
}
.notifications .readAll button:hover {
  box-shadow: var(--linkshadow);
}

.dark .notifications {
  background-color: var(--darkSecondColor);
  box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.24);
  border: 1px solid var(--darkSecondColor);
}
.dark .notifications .head {
  color: var(--darkFont);
  border-bottom: 1px solid rgba(204, 204, 204, 0.1);
}
.dark .notifications .head span {
  background-color: rgba(234, 234, 240, 0.0549019608);
}
.dark .notifications .readAll {
  border-top: 1px solid rgba(204, 204, 204, 0.1);
}

.enterNotificationsMenu {
  opacity: 0;
  top: 70px;
}

.enterActiveNotificationsMenu {
  opacity: 1;
  top: 53px;
}

.rtl .notifications {
  left: 0;
  right: unset;
}`, "",{"version":3,"sources":["webpack://./src/components/layout/Navbar/Notifications/notifications.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,4CAAA;EACA,kDAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;AACF;AACE;EACE,aAAA;EACA,8BAAA;EACA,aAAA;EACA,cAAA;EACA,mDAAA;AACJ;AAAI;EACE,eAAA;EACA,SAAA;AAEN;AAAI;EACE,eAAA;EACA,iDAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AAEN;AACE;EACE,WAAA;EACA,iBAAA;AACJ;AAAI;EACE,YAAA;AAEN;AACE;EACE,aAAA;EACA,WAAA;EACA,gDAAA;AACJ;AAAI;EACE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AAEN;AAAI;EACE,6BAAA;AAEN;;AAGE;EACE,wCAAA;EACA,4CAAA;EACA,wCAAA;AAAJ;AACI;EACE,sBAAA;EACA,iDAAA;AACN;AAAM;EACE,mDAAA;AAER;AACI;EACE,8CAAA;AACN;;AAGA;EACE,UAAA;EACA,SAAA;AAAF;;AAEA;EACE,UAAA;EACA,SAAA;AACF;;AAEE;EACE,OAAA;EACA,YAAA;AACJ","sourcesContent":[".notifications {\n  position: absolute;\n  top: 53px;\n  right: 0;\n  width: 350px;\n  background-color: #fff;\n  border-radius: 5px;\n  border: 1px solid rgba(204, 204, 204, 0.397);\n  box-shadow: 0 0 5px 0px rgba(204, 204, 204, 0.589);\n  transition: 300ms;\n  padding: 5px 0;\n  z-index: 22;\n  max-height: 400px;\n  overflow: auto;\n\n  .head {\n    display: flex;\n    justify-content: space-between;\n    padding: 10px;\n    color: #5e5873;\n    border-bottom: 1px solid rgba(204, 204, 204, 0.493);\n    p {\n      font-size: 18px;\n      margin: 0;\n    }\n    span {\n      font-size: 13px;\n      background-color: #0f7f3e1f;\n      color: #0f7f3d;\n      border-radius: 10px;\n      padding: 0 10px;\n      height: 22px;\n    }\n  }\n  .items {\n    width: 100%;\n    max-height: 300px;\n    div:last-child {\n      border: none;\n    }\n  }\n  .readAll {\n    padding: 15px;\n    width: 100%;\n    border-top: 1px solid rgba(204, 204, 204, 0.493);\n    button {\n      width: 100%;\n      border: none;\n      background: var(--linkActive);\n      color: #fff;\n      border-radius: 5px;\n      padding: 6px;\n      transition: 200ms;\n    }\n    button:hover {\n      box-shadow: var(--linkshadow);\n    }\n  }\n}\n.dark {\n  .notifications {\n    background-color: var(--darkSecondColor);\n    box-shadow: 0 4px 24px 0 rgb(0 0 0 / 24%);\n    border: 1px solid var(--darkSecondColor);\n    .head {\n      color: var(--darkFont);\n      border-bottom: 1px solid rgba(204, 204, 204, 0.1);\n      span {\n        background-color: #eaeaf00e;\n      }\n    }\n    .readAll {\n      border-top: 1px solid rgba(204, 204, 204, 0.1);\n    }\n  }\n}\n.enterNotificationsMenu {\n  opacity: 0;\n  top: 70px;\n}\n.enterActiveNotificationsMenu {\n  opacity: 1;\n  top: 53px;\n}\n.rtl {\n  .notifications {\n    left: 0;\n    right: unset;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
